<div class="max-w-1xl mx-auto bg-white p-8 rounded-lg shadow-lg">
  <div class="flex flex-wrap pb-4 justify-start">
    <h1 class="headeradminui-text pl-2">Reengagement Audit Log</h1>
  </div>
  <div class="flex flex-row justify-end mb-3">
    <div class="w-[40%]">
      <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton">
        <input
          type="text"
          nz-input
          [(ngModel)]="emailSearch"
          placeholder="Search for user email"
          (keyup.enter)="searchByEmail()"
        />
      </nz-input-group>
    </div>
  </div>

  <ng-template #suffixButton>
    <button
      nz-button
      nzType="primary"
      nzSize="small"
      nzSearch
      (click)="searchByEmail()"
    >
      Search
    </button>
  </ng-template>

  <ng-template #tableHead>
    <div nz-row nzJustify="space-between">
      <div nz-col>
        <span class="font-bold">Reengagement Cycles</span>
      </div>
      <div nz-col>
        <button
          class="btn-color"
          nz-button
          nzSize="small"
          nzType="primary"
          (click)="resetFilter()"
        >
          Clear filter
        </button>
      </div>
    </div>
  </ng-template>

  <nz-spin [nzSpinning]="pageLoading" nzTip="Fetching reengagement audit log......">
    <nz-table
      #Table
      [nzTitle]="tableHead"
      [nzScroll]="{ x: '1400px', y: '600px' }"
      class="mt-5"
      [nzData]="data"
      [nzShowPagination]="true"
      nzFrontPagination="false"
      [nzTotal]="totalCount"
      [nzPageSize]="pageSize"
      [nzBordered]="true"
      [nzShowSizeChanger]="true"
      [nzPageSizeOptions]="pageSizeOptions"
      [nzPageIndex]="gridRequest.page || 1"
      nzTableLayout="fixed"
      (nzPageIndexChange)="nzPageIndexChange($event)"
      (nzPageSizeChange)="nzPageSizeChange($event)"
    >
      <thead>
        <tr>
          <th nzWidth="140px">Created At</th>
          <th nzWidth="220px">User Email</th>
          <th nzWidth="140px">
            Partner
            <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="partnerIdDropdown">
              <span nz-icon nzType="filter" nzTheme="outline"></span>
            </nz-filter-trigger>
          </th>
          <th nzWidth="140px">
            Lifecycle State
            <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="lifecycleStateDropdown">
              <span nz-icon nzType="filter" nzTheme="outline"></span>
            </nz-filter-trigger>
          </th>
          <th nzWidth="140px">
            Capability
            <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="capabilityIdDropdown">
              <span nz-icon nzType="filter" nzTheme="outline"></span>
            </nz-filter-trigger>
          </th>
          <th nzWidth="160px">
            Dispatch Status
            <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="dispatchStatusDropdown">
              <span nz-icon nzType="filter" nzTheme="outline"></span>
            </nz-filter-trigger>
          </th>
          <th nzWidth="260px">Reasoning</th>
          <th nzWidth="260px">Content</th>
          <th nzWidth="100px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of Table.data">
          <td>{{ row.createdAt | date: 'medium' }}</td>
          <td>{{ row.userEmail }}</td>
          <td>{{ row.partnerId || '—' }}</td>
          <td>
            <nz-tag [nzColor]="lifecycleStateColor(row.lifecycleState)">
              {{ row.lifecycleState || '—' }}
            </nz-tag>
          </td>
          <td>{{ row.capabilityId || '—' }}</td>
          <td>
            <nz-tag [nzColor]="dispatchStatusColor(row.dispatchStatus)">
              {{ row.dispatchStatus }}
            </nz-tag>
          </td>
          <td>
            <div class="text-xs">
              <div *ngIf="row.angle"><strong>Angle:</strong> {{ row.angle }}</div>
              <div *ngIf="row.whyNow"><strong>Why now:</strong> {{ row.whyNow }}</div>
              <div *ngIf="!row.angle && !row.whyNow">—</div>
            </div>
          </td>
          <td>
            <div class="text-xs">
              <div *ngIf="row.pushTitle"><strong>{{ row.pushTitle }}</strong></div>
              <div *ngIf="row.pushBody" class="truncate">{{ row.pushBody }}</div>
              <div *ngIf="!row.pushTitle && !row.pushBody">—</div>
            </div>
          </td>
          <td>
            <button nz-button nzType="link" (click)="openDetails(row)">
              <i nz-icon nzType="eye"></i>
              View Details
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-spin>
</div>

<nz-dropdown-menu #partnerIdDropdown="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <span class="font-bold">Partner</span>
    </div>
    <div nz-row>
      <div nz-col>
        <nz-checkbox-wrapper (nzOnChange)="applyPartnerIdFilter($event)">
          <div *ngFor="let partner of partnerIdCheckBoxOptions" nz-row>
            <div nz-col>
              <label nz-checkbox [nzValue]="partner.value" [ngModel]="partner.checked">
                {{ partner.label }}
              </label>
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #lifecycleStateDropdown="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <span class="font-bold">Lifecycle State</span>
    </div>
    <div nz-row>
      <div nz-col>
        <nz-checkbox-wrapper (nzOnChange)="applyLifecycleStateFilter($event)">
          <div *ngFor="let state of lifecycleStateCheckBoxOptions" nz-row>
            <div nz-col>
              <label nz-checkbox [nzValue]="state.value" [ngModel]="state.checked">
                {{ state.label }}
              </label>
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #capabilityIdDropdown="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <span class="font-bold">Capability</span>
    </div>
    <div nz-row>
      <div nz-col>
        <nz-checkbox-wrapper (nzOnChange)="applyCapabilityIdFilter($event)">
          <div *ngFor="let capability of capabilityIdCheckBoxOptions" nz-row>
            <div nz-col>
              <label nz-checkbox [nzValue]="capability.value" [ngModel]="capability.checked">
                {{ capability.label }}
              </label>
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #dispatchStatusDropdown="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <span class="font-bold">Dispatch Status</span>
    </div>
    <div nz-row>
      <div nz-col>
        <nz-checkbox-wrapper (nzOnChange)="applyDispatchStatusFilter($event)">
          <div *ngFor="let status of dispatchStatusCheckBoxOptions" nz-row>
            <div nz-col>
              <label nz-checkbox [nzValue]="status.value" [ngModel]="status.checked">
                {{ status.label }}
              </label>
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-drawer
  [nzVisible]="drawerVisible"
  nzTitle="Reengagement Cycle Details"
  (nzOnClose)="closeDetails()"
  [nzWidth]="760"
>
  <ng-container *nzDrawerContent>
    <ng-container *ngIf="selectedRow">
      <div class="font-mono break-all text-sm mb-3">
        {{ selectedRow.userEmail }} · {{ selectedRow.createdAt | date: 'medium' }}
      </div>

      <div class="flex flex-wrap gap-2 mb-4">
        <nz-tag>Partner: {{ selectedRow.partnerId || '—' }}</nz-tag>
        <nz-tag [nzColor]="lifecycleStateColor(selectedRow.lifecycleState)">
          {{ selectedRow.lifecycleState || '—' }}
        </nz-tag>
        <nz-tag>Capability: {{ selectedRow.capabilityId || '—' }}</nz-tag>
        <nz-tag [nzColor]="dispatchStatusColor(selectedRow.dispatchStatus)">
          {{ selectedRow.dispatchStatus }}
        </nz-tag>
        <nz-tag *ngIf="selectedRow.wasNoSend" nzColor="default">No-Send Row</nz-tag>
      </div>

      <nz-divider nzText="Decision" nzOrientation="left"></nz-divider>
      <div class="text-sm mb-2" *ngIf="selectedRow.angle">
        <strong>Angle:</strong> {{ selectedRow.angle }}
      </div>
      <div class="text-sm mb-2" *ngIf="selectedRow.whyNow">
        <strong>Why now:</strong> {{ selectedRow.whyNow }}
      </div>
      <div class="text-sm whitespace-pre-wrap mb-4">
        <strong>Rationale:</strong>
        <p>{{ selectedRow.rationale }}</p>
      </div>

      <ng-container *ngIf="selectedRow.warnings?.length">
        <nz-divider nzText="Warnings" nzOrientation="left"></nz-divider>
        <ul class="text-sm mb-4">
          <li *ngFor="let warning of selectedRow.warnings" class="text-red-500">
            {{ warning }}
          </li>
        </ul>
      </ng-container>

      <ng-container *ngIf="selectedRow.factsUsed?.length">
        <nz-divider nzText="Facts Used" nzOrientation="left"></nz-divider>
        <nz-table
          [nzData]="selectedRow.factsUsed"
          [nzShowPagination]="false"
          nzSize="small"
          [nzBordered]="true"
          class="mb-4"
        >
          <thead>
            <tr>
              <th nzWidth="160px">Capability</th>
              <th>Claim</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let fact of selectedRow.factsUsed">
              <td>{{ fact.capabilityId }}</td>
              <td>{{ fact.claim }}</td>
            </tr>
          </tbody>
        </nz-table>
      </ng-container>

      <ng-container *ngIf="selectedRow.pushTitle || selectedRow.pushBody">
        <nz-divider nzText="Push Content" nzOrientation="left"></nz-divider>
        <div class="text-sm mb-2" *ngIf="selectedRow.pushTitle">
          <strong>Title:</strong> {{ selectedRow.pushTitle }}
        </div>
        <div class="text-sm mb-4" *ngIf="selectedRow.pushBody">
          <strong>Body:</strong> {{ selectedRow.pushBody }}
        </div>
      </ng-container>

      <ng-container *ngIf="selectedRow.pushImageUrl">
        <nz-divider nzText="Push Image" nzOrientation="left"></nz-divider>
        <img
          [src]="selectedRow.pushImageUrl"
          alt="Push image preview"
          class="max-w-full rounded-md border mb-4"
        />
      </ng-container>

      <ng-container *ngIf="selectedRow.compliance">
        <nz-divider nzText="Compliance" nzOrientation="left"></nz-divider>
        <div class="text-sm mb-2">
          <strong>Redraft occurred:</strong>
          {{ selectedRow.compliance.redraftOccurred ? 'Yes' : 'No' }}
        </div>
        <div
          class="text-sm mb-2"
          *ngIf="selectedRow.compliance.finalAttempt as attempt"
        >
          <strong>Final attempt passed:</strong>
          {{ attempt.compliance.passed ? 'Yes' : 'No' }}
          <ul
            class="list-disc pl-5"
            *ngIf="attempt.compliance.violations?.length"
          >
            <li *ngFor="let violation of attempt.compliance.violations">
              {{ violation }}
            </li>
          </ul>
        </div>
        <div
          class="text-sm mb-4"
          *ngIf="selectedRow.compliance.redraftOccurred"
        >
          <ng-container *ngIf="selectedRow.compliance.initialAttempt as attempt">
            <strong>Initial attempt passed:</strong>
            {{ attempt.compliance.passed ? 'Yes' : 'No' }}
            <ul
              class="list-disc pl-5"
              *ngIf="attempt.compliance.violations?.length"
            >
              <li *ngFor="let violation of attempt.compliance.violations">
                {{ violation }}
              </li>
            </ul>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedRow.imageGen">
        <nz-divider nzText="Image Generation" nzOrientation="left"></nz-divider>
        <div class="text-sm mb-4">
          <div>Medium: {{ selectedRow.imageGen.medium }}</div>
          <div>Attempts: {{ selectedRow.imageGen.attempts }}</div>
          <div>Verified: {{ selectedRow.imageGen.verified ? 'Yes' : 'No' }}</div>
          <div>Cost: ${{ selectedRow.imageGen.costUsd }}</div>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedRow.htmlGen">
        <nz-divider nzText="Rendered Email Preview" nzOrientation="left"></nz-divider>
        <div class="text-sm mb-2">
          Render check:
          {{ selectedRow.htmlGen.renderCheckPassed ? 'Passed' : 'Failed' }}
          (attempts: {{ selectedRow.htmlGen.attempts }})
        </div>
        <ul
          class="list-disc pl-5 text-sm text-red-600 mb-2"
          *ngIf="selectedRow.htmlGen.renderCheckErrors?.length"
        >
          <li *ngFor="let error of selectedRow.htmlGen.renderCheckErrors">
            {{ error }}
          </li>
        </ul>
        <iframe
          *ngIf="selectedHtmlPreview"
          [srcdoc]="selectedHtmlPreview"
          class="w-full border rounded-md mb-4"
          style="height: 500px"
          title="Rendered email preview"
        ></iframe>
      </ng-container>

      <nz-collapse class="mb-4">
        <nz-collapse-panel nzHeader="Fact Bundle (raw)" [nzActive]="false">
          <div class="bg-gray-50 rounded-lg p-4 max-h-80 overflow-auto">
            <pre class="text-xs font-mono whitespace-pre-wrap">{{
              selectedRow.factBundle | json
            }}</pre>
          </div>
        </nz-collapse-panel>
        <nz-collapse-panel nzHeader="Selector Decision (raw)" [nzActive]="false">
          <div class="bg-gray-50 rounded-lg p-4 max-h-80 overflow-auto">
            <pre class="text-xs font-mono whitespace-pre-wrap">{{
              selectedRow.selectorDecision | json
            }}</pre>
          </div>
        </nz-collapse-panel>
      </nz-collapse>
    </ng-container>
  </ng-container>
</nz-drawer>
